import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import Tier from '@renenet/shared/src/constants/tiers';

function TierBadge({ tier }) {
  const badge = tier === Tier.PREMIUM
    ? <Badge bg="primary">Premium Plan</Badge>
    : <Badge bg="warning" text="dark">Free Plan</Badge>;

  return (
    <Link to="/settings?section=billing" style={{ textDecoration: 'none' }}>
      {badge}
    </Link>
  );
}

export default TierBadge;
